import "./Home.css";
import { Link } from 'react-router-dom';

const heroImage = "/Images/Hero.jpg";

const species = [
  {
    image: "/Images/Container.png",
    statusClass: "vulnerable",
    status: "Vulnerable",
    scientificName: "Bucorvus leadbeateri",
    commonName: "Southern Ground Hornbill",
    description: "The Southern Ground Hornbill is Africa's largest hornbill — a slow-walking, jet-black giant with a blazing red face and a call that sounds like distant thunder.",
    population: "~1,500",
    path: "/southern-grounded-hornbill"
  },
  {
    image: "/Images/pen.png",
    statusClass: "critically",
    status: "Critically Endangered",
    scientificName: "Spheniscus demersus",
    commonName: "African Penguin",
    description: "Africa's only penguin — charismatic, monogamous, and unmistakable with its polka-dot chest and donkey-like bray — is facing a food crisis.",
    population: "<10,000",
    path: "/african-penguin"
  },
  {
    image: "/Images/Vulture.png",
    statusClass: "endangered",
    status: "Endangered",
    scientificName: "Gypaetus barbatus",
    commonName: "Bearded Vulture",
    description: "The Bearded Vulture — also known as the Lammergeier, or \"bone-breaker\" — is one of the most extraordinary birds on Earth, specialized to drop bones from great heights.",
    population: "~10,000",
    path: "/bearded-vulture"
  },
  {
    image: "/Images/Pel.png",
    statusClass: "vulnerable",
    status: "Vulnerable",
    scientificName: "Scotopelia peli",
    commonName: "Pel's Fishing Owl",
    description: "Few African birds are as mythical as Pel's Fishing Owl. Enormous, rufous, and nocturnal, it haunts the riverbanks of sub-Saharan Africa.",
    population: "70–100",
    path: "/pels-fishing-owl"
  },
  {
    image: "/Images/Cape.png",
    statusClass: "endangered",
    status: "Endangered",
    scientificName: "Morus capensis",
    commonName: "Cape Gannet",
    description: "Watch a Cape Gannet hunt and you will never forget it. From heights of up to 30 meters, it folds its wings and plunges into the sea like a living arrow.",
    population: "~120,000",
    path: "/cape-gannet"
  },
  {
    image: "/Images/Saddle-billed.png",
    statusClass: "endangered",
    status: "Endangered",
    scientificName: "Ephippiorhynchus senegalensis",
    commonName: "Saddle-billed Stork",
    description: "Standing nearly 1.5 meters tall with a wingspan of over 2.5 meters, the Saddle-billed Stork is the tallest and most striking stork in Africa.",
    population: "<250",
    path: "/saddle-billed-stork"
  },
];

export default function Home() {
  return (
    <>

      <section
        className="hero-section"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-overlay">
          <div className="hero-content">
            <div className="hero-breadcrumb">
              Save Hornbills • Conservation Initiative
            </div>

            <h1>
              Hornbills Deserve Another
              <br />
              Century of Flight
            </h1>

            <p>
              Six of Africa's most magnificent bird species are slipping
              toward extinction right now. The data is sobering. The
              community work is real. The urgent need is yours to answer.
            </p>

            <div className="hero-buttons">
              <Link to="/donate">
                <button className="hero-btn-primary">SUPPORT THE WORK</button>
              </Link>
              <Link to="/about">
                <button className="hero-btn-secondary">SEE WHAT WE DO</button>
              </Link>
            </div>
          </div>
        </div>
      </section>


      {/* QUOTE */}

      <section className="quote-section">
        <div className="container">
          <blockquote>
            At the current rate of decline, the Southern Ground
            Hornbill could be gone from South Africa within a
            generation. This isn’t a distant threat — it’s happening
            now, in landscapes our grandparents knew as teeming with
            life.
          </blockquote>
          {/* <div className="quote-attribution">
      SAVE HORNBILLS FIELD REPORT, 2024
    </div> */}
        </div>
      </section>

      {/* SPECIES */}

      <section className="species-section">
        <div className="container">
          <div className="section-header">
            <div>
              <div className="pre-title">THE CRISIS</div>
              <h2>
                Six Species.
                <br />
                One Urgent Moment.
              </h2>
            </div>
            <p className="section-desc">
              Each of these birds has survived on Earth for millions of years.
              Each is now facing a crisis that has happened entirely within
              the last century — and accelerating.
            </p>
          </div>

          <div className="species-grid">
            {species.map((item, index) => (
              <div className="species-card" key={index}>
<Link to={item.path}>
                <div className="species-img-wrap">
                  <img src={item.image} alt={item.commonName} />
                  <div className={`species-status status-${item.statusClass}`}>
                    {item.status}
                  </div>
                </div></Link>

                <div className="species-content">
                  <div className="species-scientific">{item.scientificName}</div>
                  <h5>{item.commonName}</h5>
                  <p className="species-description">{item.description}</p>

                  <div className="species-footer">
                    <div className="species-population">
                      <span className="pop-label">Population: </span>
                      <span className="pop-num">{item.population}</span>
                    </div>
                    <Link to={item.path}>
                      <p>READ MORE →</p>
                    </Link>
                  </div>
                </div>

              </div>
            ))}
          </div>
        </div>
      </section>


      {/* APPROACH */}
      <section className="approach-section">
        <div className="approach-inner">

          <div className="approach-left">
            <div className="approach-pre-title">OUR APPROACH</div>
            <h2 className="approach-heading">
              Science-Led.<br />
              Community-Powered.
            </h2>

            <p className="approach-desc">
              We don't just document decline — we work to reverse it. That means rigorous
              field science, genuine relationships with local communities, and advocacy that
              turns data into policy.
            </p>

            <p className="approach-quote">
              <em>Every dollar donated goes to work that happens on the ground, with the people and ecosystems that matter most.</em>
            </p>
            <Link to="/solution">
              <button className="approach-btn">OUR FULL APPROACH</button>
            </Link>
          </div>

          <div className="approach-right">
            <div className="feature-grid">

              <div className="feature-box">
                <div className="feature-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                    <path d="M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2v-4M9 21H5a2 2 0 01-2-2v-4m0 0h18" />
                  </svg>
                </div>
                <div className="feature-title">FIELD RESEARCH</div>
                <p className="feature-desc">Long-term population studies in 22 countries across Africa.</p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                    <path d="M17 20h5v-2a4 4 0 00-4-4h-1M9 20H4v-2a4 4 0 014-4h1m4 6v-2m0-4a4 4 0 100-8 4 4 0 000 8zm6-4a3 3 0 100-6 3 3 0 000 6zM3 12a3 3 0 100-6 3 3 0 000 6z" />
                  </svg>
                </div>
                <div className="feature-title">COMMUNITY PROGRAMS</div>
                <p className="feature-desc">Building local conservation capacity where it matters most.</p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                    <path d="M12 3C8 3 4 7 4 12c0 3 2 6 5 7.5M12 3c4 0 8 4 8 9 0 3-2 6-5 7.5M12 3v18M4 12h16" />
                  </svg>
                </div>
                <div className="feature-title">HABITAT RESTORATION</div>
                <p className="feature-desc">Restoring degraded wetlands, forests, and savanna.</p>
              </div>

              <div className="feature-box">
                <div className="feature-icon">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                    <path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div className="feature-title">POLICY ADVOCACY</div>
                <p className="feature-desc">Translating field data into enforceable legal protections.</p>
              </div>

            </div>
          </div>

        </div>
      </section>


      {/* STATS */}

      <section className="stats-section">
        <div className="container">

          <div className="stats-header">
            <div className="stats-pre-title">CONSERVATION IMPACT</div>
            <h2>Numbers That Tell the Story</h2>
          </div>

          <div className="stats-grid">





            <div className="stat-item">
              <div className="stat-number">3</div>
              <div className="stat-label">RESEARCHERS Supported</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">500+</div>
              <div className="stat-label">Website Visits Monthly</div>
            </div>

            <div className="stat-item">
              <div className="stat-number">$5200+</div>
              <div className="stat-label">INVESTMENT RAISED</div>
            </div>

          </div>
        </div>
      </section>


      {/* STORY */}

      <section className="story-section">
        <div className="container">
          <div className="story-inner">

            <div className="story-divider" />

            <blockquote className="story-quote">
              "I first saw a Southern Ground Hornbill when I was twelve — an enormous, deliberate bird walking through the grass in Kruger like it had been doing so for a thousand years. That single moment is what started all of this."
            </blockquote>

            <div className="story-attribution">MAYA NAYAK — FOUNDER, SAVE HORNBILLS</div>

            <Link to="/about">
              <button className="story-btn">OUR STORY</button>
            </Link>

          </div>
        </div>
      </section>


      {/* CTA */}

      <section className="cta-section">
        <div className="container text-center">

          <h2 className="cta-heading">
            Every Year We Wait,
            <br />
            More Is Lost
          </h2>

          <p className="cta-desc">
            African birds are disappearing at a rate not seen in recorded history. Field work
            costs money. The window to act is closing. Your support makes the work possible.
          </p>

          <div className="cta-buttons">
            <Link to="/donate">
              <button className="cta-btn-primary">DONATE NOW</button>
            </Link>
            <Link to="/about">
              <button className="cta-btn-outline">LEARN HOW WE WORK</button>
            </Link>
          </div>

        </div>
      </section>
    </>
  );
}
